import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 *
 * @param {Array} arr -> [{key, value}, {key, value}, etc]
 * @returns Object -> {key: value}
 */
export const convertArrayToObject = (arr = []) => {
  if (!Array.isArray(arr)) {
    console.log(`[ERROR] given input is not an Array`);
    return {};
  }
  return arr.reduce((acc, curr) => {
    acc[curr.key] = curr.value;
    return acc;
  }, {});
};

export function isFiniteNumber(value) {
  return Number.isFinite(value);
}

/**
 * Authentication category feature names vary by product and release:
 * product-suffixed ("Authentication SMS"/"Authentication Email", like
 * "Promotional SMS"/"Transactional Email"), bare ("Authentication") and the
 * legacy SMS name ("OTP"). Casing from the ratesheet APIs is not guaranteed.
 * "Authentication International" (WhatsApp) is deliberately excluded.
 */
export const isAuthFeatureName = (featureName = "") =>
  /^(authentication|otp)( (sms|email))?$/i.test((featureName || "").trim());

/**
 * Ratesheet category label is the API feature name as-is ("Promotional SMS",
 * "Transactional Email", "Authentication International"); only the
 * Authentication category follows the AuthConfig label, since the API still
 * sends the legacy "otp" name for SMS.
 */
export const ratesheetCategoryLabel = (
  name = "",
  authConfigEnabled = false,
  productName = ""
) => {
  const apiName = (name || "").trim();
  if (!isAuthFeatureName(apiName)) return apiName;
  // Only SMS swaps label: API still sends the legacy "OTP" name, shown as
  // "Authentication" when authconfig is on. Email/WhatsApp keep the API name.
  if (isEmailAuthCategory(apiName, productName) || /whatsapp/i.test(productName))
    return apiName === "OTP" ? "Authentication" : apiName;
  return authConfigEnabled ? "Authentication" : "OTP";
};

/**
 * The APIs send the Authentication feature name unqualified ("Authentication")
 * for every channel, so the Email one is only identifiable via the product;
 * the older suffixed name ("Authentication Email") stays supported for call
 * sites that have no product in hand.
 */
const isEmailAuthCategory = (name = "", productName = "") =>
  isAuthFeatureName(name) &&
  (/email/i.test((name || "").trim()) ||
    nameEquals(productName, "Email"));

/**
 * Email Authentication only exists with AuthConfig on; SMS keeps its legacy
 * "OTP" category either way.
 */
export const isRatesheetCategoryVisible = (
  name = "",
  authConfigEnabled = false,
  productName = ""
) => authConfigEnabled || !isEmailAuthCategory(name, productName);

export const nameEquals = (a = "", b = "") =>
  (a || "").trim().toLowerCase() === (b || "").trim().toLowerCase();
